import { render, staticRenderFns } from "./StackedRadialChart.vue?vue&type=template&id=35ad3327&scoped=true&"
import script from "./StackedRadialChart.ts?vue&type=script&lang=ts&"
export * from "./StackedRadialChart.ts?vue&type=script&lang=ts&"
import style0 from "./StackedRadialChart.scss?vue&type=style&index=0&id=35ad3327&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad3327",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VContainer,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
